import React from 'react';

import styles from './styles.scss';

export default class Error extends React.PureComponent {
  render() {
    return <div className={styles.error}>{this.props.children}</div>;
  }
}



// WEBPACK FOOTER //
// ./app/components/form/error.js